<nav *ngIf="editMode" class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button class="btnback btn btn-outline-success" type="button" (click)="onBack()" title="Volver">
            <i class="fa fa-chevron-left"></i></button>

        <button *ngIf="!visibilitySpinnerSave" [disabled]="!allowToSave" type="button" class="btn btn-outline-success" (click)="onSave()" title="Guardar">
            <i class="fa fa-save"></i> Guardar</button>
        <button *ngIf="visibilitySpinnerSave" [disabled]="true" type="button" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando</button>

        <button *ngIf="!visibilitySpinnerValidate" [disabled]="codigoSigpacNoExiste" type="button" class="btn btn-outline-success" (click)="validateOnSigPac()" title="Validación en SigPac">
            <i class="fa fa-check"></i> Validación en SigPac</button>
        <button *ngIf="visibilitySpinnerValidate" [disabled]="true" type="button" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Validando</button>

        <button *ngIf="!visibilitySpinner" [disabled]="sigpacInvalid" type="button" class="btn btn-outline-success" (click)="onShowSigpac()" title="Visualizar en SigPac">
            <i class="fa fa-external-link"></i> Visualizar en SigPac</button>
        <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Visualizando
        </button>
        <div class="nota-info">
            <label class="col-form-label" for=""><i class="fa fa-info-circle" aria-hidden="true"></i> El {{ title }} requiere ser validado en Sigpac para poder ser guardado.</label>
        </div>
    </form>
</nav>

<app-recinto-edit [editMode]="editMode" [dialogMode]="dialogMode" [recinto]="recinto" [formGroup]="formGroup" [tiposRecinto]="tiposRecinto" [provincias]="provincias" [municipios]="municipios" 
    (provinciaSelected)="onProvinciaSelected($event)" (showSigpac)="onShowSigpac()"></app-recinto-edit>
